import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60d664e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-staked-validator-item" }
const _hoisted_2 = { class: "stake-staked-validator-item__block" }
const _hoisted_3 = { class: "stake-staked-validator-item__info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "stake-staked-validator-item__info-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "over"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stake-staked-validator-item__block" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Active")
], -1))
const _hoisted_10 = { class: "stake-staked-validator-item__block" }
const _hoisted_11 = { class: "stake-staked-validator-item__block" }
const _hoisted_12 = { class: "stake-staked-validator-item__block" }

import { PropType } from "vue";
import InfoTooltip from "@/components/info-tooltip/index.vue";
import { Validator } from "@/types/staking";
import { nativeToken } from "@/stores";

const overInfo =
  "Oversubscribed info will be credited to your bonded balance for compound earning.";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-staked-validator-item',
  props: {
  validator: {
    type: Object as PropType<Validator>,
    default: null,
  },
  approxBondedAmount: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.validator.image,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(__props.validator.name != ""
                ? __props.validator.name
                : _ctx.$filters.replaceWithEllipsis(__props.validator.address, 6, 6)) + " ", 1),
            (__props.validator.isHighRisk)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "High risk"))
              : _createCommentVNode("", true)
          ]),
          (!__props.validator.isOversubscribed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.validator.nominators) + " nominators ", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" Oversubscribed " + _toDisplayString(__props.validator.nominators) + " ", 1),
                _createVNode(InfoTooltip, { text: overInfo })
              ]))
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(__props.validator.commission.toFixed(2)) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.validator.total || 0)) + " " + _toDisplayString(_unref(nativeToken).symbol.toLocaleUpperCase()), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.approxBondedAmount || 0)) + " " + _toDisplayString(_unref(nativeToken).symbol.toLocaleUpperCase()), 1)
    ])
  ]))
}
}

})